export const ABOUT = {
  headline: 'A bit about <em>me.</em>',
  paragraphs: [
    'I take AI products from prototype to production. That means Python, FastAPI, Docker, Kubernetes and cloud infra, but mostly it means owning the metric after launch, not just the notebook before it.',
    'Right now I am an Artificial Intelligence Engineer at ORCAWISE in Dublin, fine-tuning Llama models with SFT, LoRA and RLHF, and running an agentic RAG platform over 10,000+ enterprise documents. Before that I spent four years at Panghat building semantic search over 500,000+ legal cases. It beat BM25 by 35%, and the RAG assistant scored 92% on answer relevance.',
    'On the side I founded MyNextRoom, a rental marketplace for Ireland with ML fraud detection, and I make videos about production ML as ActuallyIndian_AI. I did an MSc in Human-Centered AI at TU Dublin, mostly on explainability and what it takes to trust a model in a regulated setting.',
    'Away from the laptop I play football every week and watch a lot more of it than I probably should. I support Barcelona, and as far as I am concerned the Messi debate was settled a long time ago.',
  ],
  facts: [
    { label: 'Based', value: 'Dublin, Ireland' },
    { label: 'Work status', value: 'Stamp 1G, full right to work in Ireland' },
    { label: 'Education', value: 'MSc Human-Centered AI, TU Dublin' },
    { label: 'Open to', value: 'AI Engineer, Applied ML, founding roles' },
  ],
  photo: {
    label: 'Wicklow, on a rare dry day',
    caption: 'Off duty, allegedly.',
  },
  availability: {
    status: 'Open to opportunities',
    roles: 'AI Engineer, Applied ML, Founding Engineer',
    location: 'Dublin or remote in the EU',
    start: 'Available now',
  },
};
